import { AppPaths } from "@app/router/paths";
import { OPEN_LEAVE_CARD_QUERY_PARAM } from "@app/router/queryParams";
import { SoType } from "@src/api/so";
import { limitCardsServices } from "@src/api/stock/limitCards";
import { buildUrl } from "@shared/utils/buildUrl";
import { BalanceDocType } from "@src/types/business/balanceDocType";

export interface SearchObjectNavigationVariant {
    name: string;
    path: string;
}

/**
 * Варианты навигации после поиска СО (`so.findOmpObject`).
 * Ориентируемся по `soType` из справочника СО ({@link SoType}), не по `BoType`.
 */
export async function buildSearchObjectVariants(soType: number, soCode: number): Promise<SearchObjectNavigationVariant[]> {
    switch (soType) {
        case SoType["Акт инвентаризации УП"]:
            return [
                {
                    name: "Акт инвентаризации УП",
                    path: AppPaths.WORKSHOP.INV_ACTS.CARD(String(soCode)),
                },
            ];

        case SoType["Лимитная карта"]:
            return [
                {
                    name: "Лимитная карта",
                    path: AppPaths.WORKSHOP.LIMIT_CARDS.CARD(String(soCode)),
                },
            ];

        case SoType["Отпуск по лимитной карте"]: {
            const limitCardCode = await limitCardsServices.loadLimitCardCodeByLeaveCode(soCode);
            return [
                {
                    name: "Отпуск по лимитной карте",
                    path: buildUrl(AppPaths.WORKSHOP.LIMIT_CARDS.CARD(String(limitCardCode)), {
                        [OPEN_LEAVE_CARD_QUERY_PARAM]: soCode,
                    }),
                },
            ];
        }

        case SoType["Внутризаводская накладная УП"]:
            return [
                {
                    name: "Внутризаводская накладная УП (Приход)",
                    path: AppPaths.WORKSHOP.INPLANTS.CARD(BalanceDocType.Arrival, String(soCode)),
                },
                {
                    name: "Внутризаводская накладная УП (Расход)",
                    path: AppPaths.WORKSHOP.INPLANTS.CARD(BalanceDocType.Leave, String(soCode)),
                },
            ];

        default:
            return [];
    }
}
